<template>
  <div>
    <title-bar :title-stack="titleStack"/>
    <hero-bar :has-right-visible="false">
      Dashboard
    </hero-bar>
    <section class="section is-main-section">
      <tiles>
        <card-widget class="tile is-child" type="is-secondary" icon="account-multiple" label="Invitados" v-bind="invited"/>
        <card-widget class="tile is-child" type="is-primary" icon="account-multiple" label="Reclamados" v-bind="claimed"/>
        <card-widget class="tile is-child" type="is-warning" icon="account-multiple" label="Cambiaron clave" v-bind="changedPassword"/>
        <card-widget class="tile is-child" type="is-info" icon="account-multiple" label="Respondieron mal" v-bind="wrongAnswer"/>
      </tiles>

      <card-component title="Números por fechas" icon="account-multiple">
        <div class="buttons has-addons filter-for-card">
          <b-field grouped group-multiline>
            <label class="label label-for-line-chart">Fechas</label>
            <b-datepicker
              class="datepicker-for-linechart"
              v-model="datesLine"
              v-on:input="fillChartData"
              :max-date="maxDate"
              range>
            </b-datepicker>
          </b-field>
        </div>
        <div v-if="defaultChart.chartData" class="chart-area">
          <line-chart style="height: 100%"
                      ref="bigChart"
                      chart-id="big-line-chart"
                      :chart-data="defaultChart.chartData"
                      :extra-options="defaultChart.extraOptions">
          </line-chart>
        </div>
        <b-loading :is-full-page="false" :active.sync="isLoading"/>
      </card-component>
      <historical-card-table/>
    </section>
  </div>
</template>

<style>
  .filter-for-card {
    padding-left: 2rem;
    margin-top: -.5rem;
    margin-bottom: -.5rem;
  }
  .label-for-line-chart {
    padding-right: 1rem;
  }
  .datepicker-for-linechart {
    margin-top: -.3rem;
    width: 14.75em;
  }
</style>

<script>
import * as chartConfig from '@/components/Charts/chart.config'
import HeroBar from '@/components/HeroBar'
import TitleBar from '@/components/TitleBar'
import Tiles from '@/components/Tiles'
import CardWidget from '@/components/CardWidget'
import CardComponent from '@/components/CardComponent'
import LineChart from '@/components/Charts/LineChart'
import ReportsRepository from '@/services/ReportsRepository'
import HistoricalCardTable from '@/components/historical/HistoricalCardTable'

export default {
  name: 'home',
  components: {
    TitleBar,
    HeroBar,
    LineChart,
    CardComponent,
    CardWidget,
    HistoricalCardTable,
    Tiles
  },
  data () {
    return {
      defaultChart: {
        chartData: null,
        extraOptions: chartConfig.chartOptionsMain
      },
      invited: {
        number: 0,
        percentage: 0,
        prefixSign: '+',
        suffix: '%'
      },
      claimed: {
        number: 0,
        percentage: 0,
        prefixSign: '+',
        suffix: '%'
      },
      changedPassword: {
        number: 0,
        percentage: 0,
        prefixSign: '+',
        suffix: '%'
      },
      wrongAnswer: {
        number: 0,
        percentage: 0,
        suffix: ''
      },
      daysBefore: 6,
      isLoading: true,
      datesLine: [],
      maxDate: new Date()
    }
  },
  computed: {
    titleStack () {
      return [
        'Admin',
        'Dashboard'
      ]
    }
  },
  mounted () {
    var dateOffset = (24 * 60 * 60 * 1000) * 7
    var daysBefore = new Date()
    daysBefore.setTime(daysBefore.getTime() - dateOffset)
    this.datesLine = [daysBefore, this.maxDate]
    this.loadCardWidgets()
    this.fillChartData()
    this.$buefy.snackbar.open({
      message: 'Bienvenido',
      queue: false
    })
  },
  methods: {
    lineChart (data, color) {
      return {
        fill: false,
        data: data,
        borderColor: color,
        borderWidth: 2,
        borderDash: [],
        borderDashOffset: 0.0,
        pointBackgroundColor: color,
        pointBorderColor: 'rgba(255,255,255,0)',
        pointHoverBackgroundColor: color,
        pointBorderWidth: 20,
        pointHoverRadius: 4,
        pointHoverBorderWidth: 15,
        pointRadius: 4
      }
    },
    fillChartData () {
      console.log(this.datesLine[0])
      console.log(this.datesLine[1])
      const params = {
        start_date: this.parseDateForService(this.datesLine[0]),
        end_date: this.parseDateForService(this.datesLine[1])
      }
      this.isLoading = true
      console.log(params)
      ReportsRepository.getDailyReport(params).then((result) => {
        this.isLoading = false
        const invited = []
        const claimed = []
        const changedPassword = []
        const wrongAnswer = []

        const labels = []
        for (let i = 0; i < result.data.length; i++) {
          invited.push(result.data[i].invited)
          claimed.push(result.data[i].claimed)
          changedPassword.push(result.data[i].changed_password)
          wrongAnswer.push(result.data[i].wrong_answer)
          labels.push(this.parseDateForLineChart(result.data[i].date))
        }
        const datasets = []
        datasets.push(this.lineChart(invited, chartConfig.chartColors.default.secondary))
        datasets.push(this.lineChart(claimed, chartConfig.chartColors.default.primary))
        datasets.push(this.lineChart(changedPassword, '#ffdd57'))
        datasets.push(this.lineChart(wrongAnswer, chartConfig.chartColors.default.info))
        this.defaultChart.chartData = {
          datasets: datasets,
          labels: labels
        }
      })
    },
    loadCardWidgets () {
      ReportsRepository.getTodayReport().then((result) => {
        for (let i = 0; i < result.data.length; i++) {
          if (result.data[i].status === 0) this.setCardWidgetValues(this.invited, result.data[i])
          else if (result.data[i].status === 1) this.setCardWidgetValues(this.claimed, result.data[i])
          else if (result.data[i].status === 2) this.setCardWidgetValues(this.changedPassword, result.data[i])
          // else if (result.data[i].status === 3) this.setCardWidgetValues(this.wrongAnswer, result.data[i])
        }
      }).catch(e => {
        if (e.response.status === 401) {
          this.$router.push('login')
        } else {
          this.$buefy.toast.open({
            message: `Error: ${e.message}`,
            type: 'is-danger'
          })
        }
      })
    },
    setCardWidgetValues (dict, data) {
      dict.number = data.number
      dict.percentage = data.number_compared
      dict.suffix = data.suffix
    },
    setCardWidgetValues2 (dict, previousValue) {
      if (previousValue !== 0) {
        if (previousValue > dict.number) dict.prefixSign = '-'

        dict.percentage = Math.ceil(100 * Math.abs(dict.number - previousValue) / previousValue)
      } else {
        dict.percentage = dict.number
        dict.suffix = ''
      }
    },
    parseDateForService (mdate) {
      const datetime = new Date(mdate)
      const dateTimeFormat = datetime.getDate() + '/' + (datetime.getUTCMonth() + 1) + '/' + datetime.getFullYear()
      return dateTimeFormat
    },
    parseDateForLineChart (mdate) {
      const datetime = new Date(mdate)
      const dateTimeFormat = datetime.getUTCDate() + '/' + (datetime.getUTCMonth() + 1)
      return dateTimeFormat
    },
    resetPageAndLoad () {
      this.forTable.currentPage = 1
      this.loadHistoricalResponses()
    }
  }
}
</script>
